import { Component } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { CountryList } from '../interface/country-data';
import { MydownlineData } from '../interface/downline-report-methods';
import { Months } from '../enums/months.enum';
import { DistributorLevel } from '../enums/distributor-level.enum';
import { CustomerService } from '../services/customer.service';
import * as moment from 'moment/moment';
import { DatePipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { environment } from '../../../environments/environment';
import { ImgSrcConstants } from '../../common/constants/imgsrc.constants';
import { AppLoaderService } from '../../shared/services/app-loader.service';
import { NumberFormat } from '../../common/pipes/number-format.pipe';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';

@Component({
    selector: 'downline-report',
    templateUrl: '../templates/template1/views/downline-report.component.html',
    providers: [DecimalPipe, CurrencyPipe, NumberFormat, TitleCasePipe],
    styleUrls: ['../templates/template1/themes/default/css/mydownline-report.component.less'],
})

export class MydownlineReportComponent {
    excelImageUrl: string;
    country: string;
    errormessage: boolean = false;
    homeCountry: CountryList;
    selectedCountry: CountryList;
    countries: CountryList[] = [];
    distributorId: string = '440100400540';
    userInfo: any;
    months = Months;
    monthValues: Array<{ id: any, itemName: any }> = [];
    recentYears: Array<any> = [];
    recentMonths: Array<any> = [];
    fboLevels: Array<{ id: any, itemName: any }> = [];
    selectedLevels: Array<any> = [];
    levels: any = DistributorLevel;
    multiSelectSetting: any;
    isOpen: boolean = true;
    expandingLevel: number = 1;
    level: number = 0;
    ownerIdorName: string;
    year: number = 0;
    month: number = 0;
    distributorLevel: string = '';
    hideZeroCC: boolean;
    sortOption: string = '';
    requestObject: MydownlineData;
    sortType: boolean = true; // true= ascending ; false= descending
    mydate: string;
    userName: string;
    data: Array<any>;
    monthFlag: Boolean = false;
    removeKeys = ['$$gtRowId'];
    homeCountryCode: string;
    localizedKey: any;


    constructor(private _commonService: CustomerService,
        private _localStorageService: LocalStorageService,
        private _downline: CustomerService,
        private _datePipe: DatePipe,
        private _loader: AppLoaderService,
        private _translatePipe: TranslateService,
        private _decimalPipe: DecimalPipe,
        private _currencyPipe: CurrencyPipe,
        private _numberFormatPipe: NumberFormat,
        private _titleCasePipe: TitleCasePipe,
    ) {
    }

    ngOnInit() {
        this.userInfo = this._localStorageService.get('UserInfo');
        this.mydate = this._datePipe.transform(new Date(), 'dd-MMM-yyyy');
        this.userName = this.userInfo['firstName'] + ' ' + this.userInfo['lastName'];
        // this.distributorId = this.userInfo['distributorId'];
        this.homeCountryCode  =  'GBR';//localStorage.getItem('appadmin.homeCountryCode');
        this.getCountries(this.distributorId, this.homeCountryCode);
        this.getRecentMonthYear();
        this.getExportImageUrls();
        this._commonService.getTransaltedText().subscribe(
            (res: any) => {
                if (res != null) {
                    this.multiSelectSetting = {

                        singleSelection: false,
                        text: this._translatePipe.get('ticketing-system.Select')['value'] || 'Select',
                        selectAllText: this._translatePipe.get('mydownline.Select All')['value'] || 'Select All',
                        unSelectAllText: this._translatePipe.get('mydownline.UnSelect All')['value'] || 'UnSelect All',
                        enableSearchFilter: true,
                        maxHeight: 150,
                        badgeShowLimit: '1',
                        classes: 'myclass custom-class'
                    };
                }
                else {
                    this.multiSelectSetting = {
                        singleSelection: false,
                        text:'Select',
                        selectAllText: 'Select All',
                        unSelectAllText: 'UnSelect All',
                        enableSearchFilter: true,
                        maxHeight: 150,
                        badgeShowLimit: '1',
                        classes: 'myclass custom-class'
                    };
                }
                this.getTranslatedFBOLevelandMonths();
            }
        );
    }

    getDownLineMemberDetail(distributorId: string, level: number, ownerIdorName: string, sortOption: string): void {
        this._loader.show();
        this._downline.getDownLineMemberDetail(distributorId, null, this.year, this.month, this.country, this.distributorLevel, this.hideZeroCC, this.sortOption, this.expandingLevel, 0)
            .subscribe((res: any) => {
                this.data = res;
                this._loader.hide();
                this.isOpen = this.data[0].downLineMembers.length == 0 ? false : true
            },
                error => {
                    this.errormessage = true;
                });
    }

    setYear(year: number): void {
        this.year = year;
    }

    setMonth(month: number): void {
        this.month = month;
    }

    getDownlineDetailsBySortOption(sortOption: string): void {
        let temp = this.sortOption.replace('-', '')
        if (temp === sortOption) {
            if (this.sortOption.indexOf('-') === -1) {
                this.sortType = false;
                this.sortOption = '-' + sortOption;
            }
            else {
                this.sortType = true;
                this.sortOption = sortOption;
            }
        }
        else {
            this.sortType = true;
            this.sortOption = sortOption;
        }

        let value = this.sortOption.includes('_') ? this.sortOption.substr(0, this.sortOption.indexOf('_')) : this.sortOption;

        this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, value)
    }

    getDownlineDetailsByHideZeroPersonalCC(): void {
        this.year = 0;
        this.month = 0;
        this.distributorLevel = '';
        this.expandingLevel = 1;
        this.hideZeroCC = !this.hideZeroCC;
        this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
    }

    expandNextLevel(): void {
        this.year = 0;
        this.month = 0;
        this.distributorLevel = '';
        this.expandingLevel = this.expandingLevel + 1;
        this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
    }

    getRecentMonthYear(): void {
        let currentYear = new Date().getFullYear();
        let currentMonth = new Date().getMonth() + 1;

        this.getRecentMonths(currentMonth);

        this.recentYears.push(+currentYear - 2);
        this.recentYears.push(+currentYear - 1);
        this.recentYears.push(currentYear);

    }

    getRecentMonths(currentMonth: number): void {
        this.recentMonths.push(moment((currentMonth - 2) === 0 ? 12 : (currentMonth - 2) === -1 ? 11 : (currentMonth - 2), 'MM' || 'M').format('MMM'));
        this.recentMonths.push(moment((currentMonth - 1) === 0 ? 12 : (currentMonth - 1), 'MM' || 'M').format('MMM'));
        this.recentMonths.push(moment(currentMonth, 'MM' || 'M').format('MMM'));
    }

    /**
     * getCountries Method used to get the country list
     * @param  {number} distributorId
     * @returns void
     */
    getCountries(distributorId: string, homeCountry: string): void {
        this._commonService
            .getCountries(distributorId, homeCountry)
            .subscribe(res => {
                if (res.length > 0 && res != null) {
                    res.forEach((element: any) => {
                        let country: CountryList = { name: '', value: '' };
                        country.name = element.countryName;
                        country.value = (element.countryName.indexOf('/') > -1 ? element.countryName.replace('/', ',') : element.countryName);
                        if (element.homeCountry == true || element.homeCountry === 'true') {

                            this.selectedCountry = this.homeCountry = country;
                        }
                        this.countries.push(country);
                    });
                    this.country = this.homeCountry.value !== null && this.homeCountry.value !== undefined ? this.homeCountry.value.substr(0, 3) : '';
                    this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
                }
            },
                error => {
                    this.errormessage = true;
                });
    }

    /**
     * changeCountry Method used to get the recruitment data based on country selected
     * @param  {string} country
     * @returns void
     */
    changeCountry(country: string): void {
        this.country = (country.indexOf('/') > -1 ? country.replace('/', ',') : country);
        this.country = this.country.substring(0, 3)
        this.year = 0;
        this.month = 0;

        this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
    }

    getTranslatedFBOLevelandMonths(): void {
        let levelList = Object.keys(this.levels).map(k => this.levels[k]).filter(v => typeof v === 'string') as string[];
        levelList.forEach((item: any) => {
            this.fboLevels.push({ id: this._translatePipe.get('mydownline.' + item)['value'], itemName: this._translatePipe.get('mydownline.' + item)['value'] });
        });

        let monthList = Object.keys(this.months).map(k => this.months[k]).filter(v => typeof v === 'string') as string[];
        let id = 1;
        monthList.forEach((item: any) => {
            this.monthValues.push({ id: id, itemName: this._translatePipe.get('mydownline.' + item)['value'] });
            id = id + 1;
        });
    }

    onItemSelect(item: any) {

    }

    OnItemDeSelect(item: any) {

    }
    onSelectAll(items: any) {
    }
    onDeSelectAll(items: any) {
    }

    getDownlineByFilters(): void {
        this.distributorLevel = '';
        this.expandingLevel = 1;

        let currentMonth = new Date().getMonth() + 1;
        let currentYear = new Date().getFullYear();

        if (this.month == 0) {
            this.recentMonths = [];
            this.getRecentMonths(currentMonth);
        } else {
            this.recentMonths = [];
            this.getRecentMonths(this.month);
        }
        
        if (+this.year == currentYear && +this.month > currentMonth) {
            this.monthFlag = true;
        }
        else {
            this.monthFlag = false;

            this.selectedLevels.forEach(element => {
                this.distributorLevel = this.distributorLevel + " " + element.itemName + ",";
            });
            this.distributorLevel = this.distributorLevel.substr(0, this.distributorLevel.length - 1);


            if (this.ownerIdorName !== null && this.ownerIdorName !== undefined && this.ownerIdorName.toString() !== '') {
                this.getDownLineMemberDetail(this.ownerIdorName, this.expandingLevel, this.ownerIdorName, this.sortOption);
            }
            else {
                this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
            }
        }
    }

    /**
   * downloadExcel Method used to create the excel file
   * @returns void
   */
    downloadExcel(): void {

        let data: Array<any> = [];

        data = this.prepareExcelData(this.data, false);


        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        const wbout: string = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout]), this._translatePipe.get('mydownline.My Downline Volume')['value'] + '.xlsx');
    }

    getTranslatedMonth(month: string) {
        return this._translatePipe.get('common.' + month)['value'];
    }

    prepareExcelData(downlineData: any, flag: Boolean): Array<any> {
        let data: Array<any> = [];
        let mydownlineData: MydownlineData

        downlineData.forEach((element: any) => {
            mydownlineData = {
                name: element['name'],
                gen: element['generation'],
                id: element['distributorFormatedId'],
                title: element['level'],
                country: element['country'],
                sponsorDate: element['sponsorDate'],
                phone: element['phone'],
                email: element['email'],
                activeCCMonthOne: element['active'].monthOne,
                activeCCMonthTwo: element['active'].monthTwo,
                activeCCMonthThree: element['active'].monthThree,
                personalCCMonthOne: (element['personalCC'].monthOne === null ? '0.0' : element['personalCC'].monthOne),
                personalCCMonthTwo: (element['personalCC'].monthTwo === null ? '0.0' : element['personalCC'].monthTwo),
                personalCCMonthThree: (element['personalCC'].monthThree === null ? '0.0' : element['personalCC'].monthThree),
                totalCCMonthOne: (element['totalCC'].monthOne === null ? '0.0' : element['totalCC'].monthOne),
                totalCCMonthTwo: (element['totalCC'].monthTwo === null ? '0.0' : element['totalCC'].monthTwo),
                totalCCMonthThree: (element['totalCC'].monthThree === null ? '0.0' : element['totalCC'].monthThree),
                totalGlobalCCYTD: element['totalGlobalCCYTD'],
                totalActiveCCMonthOne: (element['totalActiveCC'].monthOne === null ? '0.0' : element['totalActiveCC'].monthOne),
                totalActiveCCMonthTwo: (element['totalActiveCC'].monthTwo === null ? '0.0' : element['totalActiveCC'].monthTwo),
                totalActiveCCMonthThree: (element['totalActiveCC'].monthThree === null ? '0.0' : element['totalActiveCC'].monthThree),
                totalActiveCCYTD: (element['totalActiveCC'].ytd === null ? '0.0' : element['totalActiveCC'].ytd),
                nonManagerCCMonthOne: (element['nonManagerCC'].monthOne === null ? '0.0' : element['nonManagerCC'].monthOne),
                nonManagerCCMonthTwo: (element['nonManagerCC'].monthTwo === null ? '0.0' : element['nonManagerCC'].monthTwo),
                nonManagerCCMonthThree: (element['nonManagerCC'].monthThree === null ? '0.0' : element['nonManagerCC'].monthThree),
                nonManagerCCYTD: (element['nonManagerCC'].ytd === null ? '0.0' : element['nonManagerCC'].ytd),
                leadershipCCMonthOne: (element['leadershipCC'].monthOne === null ? '0.0' : element['leadershipCC'].monthOne),
                leadershipCCMonthTwo: (element['leadershipCC'].monthTwo === null ? '0.0' : element['leadershipCC'].monthTwo),
                leadershipCCMonthThree: (element['leadershipCC'].monthThree === null ? '0.0' : element['leadershipCC'].monthThree),
                leadershipCCYTD: (element['leadershipCC'].ytd === null ? '0.0' : element['leadershipCC'].ytd),
                newEagleManagerGlobalCC: element['newEagleManagerGlobalCC'],
                newChairmansBonusGlobalCC: element['newChairmansBonusGlobalCC']
            };

            data.push(this.getTranslatedData(this.removeKeys, mydownlineData));

            if (element['hasDownLine'] === true && element['downLineMembers'].length > 0) {
                let temp = this.prepareExcelData(element['downLineMembers'], true);

                data = data.concat(temp);
            }
        })

        return data;
    }
    /**
 * prepareExcelData Method used to prepare the data to be exported to excel file by removing unwanted columns
 * @param  {any} keys
 * @param  {any} data
 * @returns object
 */
    getTranslatedData(keys: any, data: any): object {
        var exportData = Object.keys(data).reduce((obj, key) => {
            if (keys.indexOf(key) === -1) {
                if (key == 'name') {
                    key = this._translatePipe.get('common.Name')['value'] || 'Name'
                    return { ...obj, [key]: (data['name']) }
                } else if (key == 'gen') {
                    key = this._translatePipe.get('mydownline.Generation')['value'] || 'Generation'
                    return { ...obj, [key]: (data['gen']) }
                } else if (key == 'level') {
                    key = this._translatePipe.get('mydownline.Title')['value'] || 'Title'
                    return { ...obj, [key]: (data['level']) }
                } else if (key == 'country') {
                    key = this._translatePipe.get('common.Country')['value'] || 'Country'
                    return { ...obj, [key]: (data['country']) }
                } else if (key == 'sponsorDate') {
                    key = this._translatePipe.get('mydownline.Sponsor Date')['value'] || 'Sponsor Date'
                    return { ...obj, [key]: (data['sponsorDate']) }
                } else if (key == 'phone') {
                    key = this._translatePipe.get('mydownline.Phone')['value'] || 'Phone'
                    return { ...obj, [key]: (data['phone']) }
                } else if (key == 'email') {
                    key = this._translatePipe.get('common.Email')['value'] || 'Email'
                    return { ...obj, [key]: (data['email']) }
                } else if (key == 'id') {
                    key = this._translatePipe.get('mydownline.FBO ID')['value'] || 'FBO ID'
                    return { ...obj, [key]: (data['id']) }
                } else if (key == 'newEagleManagerGlobalCC') {
                    key = this._translatePipe.get('mydownline.New Eagle Manager')['value'] + ' ' + this._translatePipe.get('mydownline.Global CC')['value'] || 'New Eagle Manager Global CC'
                    return { ...obj, [key]: (data['newEagleManagerGlobalCC']) }
                } else if (key == 'newChairmansBonusGlobalCC') {
                    key = this._translatePipe.get('mydownline.New Chairmans Bonus')['value'] + ' ' + this._translatePipe.get('mydownline.Global CC')['value'] || 'New Chairmans Bonus Global CC'
                    return { ...obj, [key]: (data['newChairmansBonusGlobalCC']) }
                } else if (key == 'activeCCMonthOne') {
                    key = this._translatePipe.get('common.Active')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[0]) || 'Active - ' + this.recentMonths[0]
                    return { ...obj, [key]: (data['activeCCMonthOne']) }
                } else if (key == 'activeCCMonthTwo') {
                    key = this._translatePipe.get('common.Active')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[1]) || 'Active - ' + this.recentMonths[1]
                    return { ...obj, [key]: (data['activeCCMonthTwo']) }
                } else if (key == 'activeCCMonthThree') {
                    key = this._translatePipe.get('common.Active')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[2]) || 'Active - ' + this.recentMonths[2]
                    return { ...obj, [key]: (data['activeCCMonthThree']) }
                } else if (key == 'personalCCMonthOne') {
                    key = this._translatePipe.get('common.Personal CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[0]) || 'Personal CC - ' + this.recentMonths[0]
                    return { ...obj, [key]: (data['personalCCMonthOne']) }
                } else if (key == 'personalCCMonthTwo') {
                    key = this._translatePipe.get('common.Personal CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[1]) || 'Personal CC - ' + this.recentMonths[1]
                    return { ...obj, [key]: (data['personalCCMonthTwo']) }
                } else if (key == 'personalCCMonthThree') {
                    key = this._translatePipe.get('common.Personal CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[2]) || 'Personal CC - ' + this.recentMonths[2]
                    return { ...obj, [key]: (data['personalCCMonthThree']) }
                } else if (key == 'totalCCMonthOne') {
                    key = this._translatePipe.get('common.Total CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[0]) || 'Total CC - ' + this.recentMonths[0]
                    return { ...obj, [key]: (data['totalCCMonthOne']) }
                } else if (key == 'totalCCMonthTwo') {
                    key = this._translatePipe.get('common.Total CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[1]) || 'Total CC - ' + this.recentMonths[1]
                    return { ...obj, [key]: (data['totalCCMonthTwo']) }
                } else if (key == 'totalCCMonthThree') {
                    key = this._translatePipe.get('common.Total CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[2]) || 'Total CC - ' + this.recentMonths[2]
                    return { ...obj, [key]: (data['totalCCMonthThree']) }
                } else if (key == 'totalGlobalCCYTD') {
                    key = this._translatePipe.get('mydownline.Total Global CC')['value'] + this._translatePipe.get('mydownline.YTD')['value'] || 'Total Global CC YTD'
                    return { ...obj, [key]: (data['totalGlobalCCYTD']) }
                } else if (key == 'totalActiveCCMonthOne') {
                    key = this._translatePipe.get('common.Total Active CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[0]) || 'Total Active CC - ' + this.recentMonths[0]
                    return { ...obj, [key]: (data['totalActiveCCMonthOne']) }
                } else if (key == 'totalActiveCCMonthTwo') {
                    key = this._translatePipe.get('common.Total Active CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[1]) || 'Total Active CC - ' + this.recentMonths[1]
                    return { ...obj, [key]: (data['totalActiveCCMonthTwo']) }
                } else if (key == 'totalActiveCCMonthThree') {
                    key = this._translatePipe.get('common.Total Active CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[2]) || 'Total Active CC - ' + this.recentMonths[2]
                    return { ...obj, [key]: (data['totalActiveCCMonthThree']) }
                } else if (key == 'totalActiveCCYTD') {
                    key = this._translatePipe.get('common.Total Active CC')['value'] + ' - ' + this._translatePipe.get('mydownline.YTD')['value'] || 'Total Active CC - YTD'
                    return { ...obj, [key]: (data['totalActiveCCYTD']) }
                } else if (key == 'nonManagerCCMonthOne') {
                    key = this._translatePipe.get('common.Non-Manager CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[0]) || 'Non-Manager CC - ' + this.recentMonths[0]
                    return { ...obj, [key]: (data['nonManagerCCMonthOne']) }
                } else if (key == 'nonManagerCCMonthTwo') {
                    key = this._translatePipe.get('common.Non-Manager CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[1]) || 'Non-Manager CC - ' + this.recentMonths[1]
                    return { ...obj, [key]: (data['nonManagerCCMonthTwo']) }
                } else if (key == 'nonManagerCCMonthThree') {
                    key = this._translatePipe.get('common.Non-Manager CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[2]) || 'Non-Manager CC - ' + this.recentMonths[2]
                    return { ...obj, [key]: (data['nonManagerCCMonthThree']) }
                } else if (key == 'nonManagerCCYTD') {
                    key = this._translatePipe.get('common.Non-Manager CC')['value'] + ' - ' + this._translatePipe.get('mydownline.YTD')['value'] || 'Non-Manager CC - YTD'
                    return { ...obj, [key]: (data['nonManagerCCYTD']) }
                } else if (key == 'leadershipCCMonthOne') {
                    key = this._translatePipe.get('mydownline.Leadership CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[0]) || 'Leadership CC - ' + this.recentMonths[0]
                    return { ...obj, [key]: (data['leadershipCCMonthOne']) }
                } else if (key == 'leadershipCCMonthTwo') {
                    key = this._translatePipe.get('mydownline.Leadership CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[1]) || 'Leadership CC - ' + this.recentMonths[1]
                    return { ...obj, [key]: (data['leadershipCCMonthTwo']) }
                } else if (key == 'leadershipCCMonthThree') {
                    key = this._translatePipe.get('mydownline.Leadership CC')['value'] + ' - ' + this.getTranslatedMonth(this.recentMonths[2]) || 'Leadership CC - ' + this.recentMonths[2]
                    return { ...obj, [key]: (data['leadershipCCMonthThree']) }
                } else if (key == 'leadershipCCYTD') {
                    key = this._translatePipe.get('mydownline.Leadership CC')['value'] + ' - ' + this._translatePipe.get('mydownline.YTD')['value'] || 'Leadership CC - YTD'
                    return { ...obj, [key]: (data['leadershipCCYTD']) }
                } else {
                    return { ...obj, [key]: data[key] }
                }

            }
            return obj
        }, {});
        return exportData;
    }

    /**
     * getExportImageUrls Method used to get the image source path for Exports 
     * @returns void
     */
    getExportImageUrls(): void {
        if (process.env.ENV === 'production') {
            //   this.pdfImageUrl =environment.baseHref + '/resources/static/' + ImgSrcConstants.exportImgUrl + 'pdf' + '.ico';
            this.excelImageUrl = environment.baseHref + '/resources/static/' + ImgSrcConstants.exportImgUrl + 'excel' + '.ico';
        } else {
            //   this.pdfImageUrl =environment.baseHref + ImgSrcConstants.exportImgUrl + 'pdf' + '.ico';
            this.excelImageUrl = environment.baseHref + ImgSrcConstants.exportImgUrl + 'excel' + '.ico';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/downline-report.component.ts